const firebase = require('firebase/app')
require('firebase/database')
const {config} = require('./config')

firebase.initializeApp(config)

export function addUrl(data) {
  firebase.database().ref('urls').push(data)
}

export function getRoom(roomId) {
  return firebase.database().ref(roomId)
}

export function deletePerson(roomId, person) {
  firebase.database().ref(roomId + "/" + person).remove()
}

export function deleteTile(roomId, person, key) {
  firebase.database().ref(roomId + "/" + person + "/" + key).remove()
}

export function toggleModVisibility(roomId, person, key, hidden) {
  firebase.database().ref(roomId + "/" + person + "/" + key + "/hidden").set(!hidden)
}

export function checkRoom(roomId) {
  return firebase.database().ref(roomId)
}

export function addCustomEvent(roomId, person, tileDetails) {
  let tile = {
    day: tileDetails.day,
    start: tileDetails.start,
    end: tileDetails.end,
    module_code: tileDetails.name,
    type: "",
    venue: "",
    custom: true,
    hidden: false,
    week:""
  }

  firebase.database().ref(roomId + "/" + person).push(tile)
}